/** Tooltip texts of Admin > Manage > Rate Limits, written for product owners (no code words). */

export const RL_TIPS = {
  rateLimitsMode: [
    'How the rate limits behave right now. A developer sets it on the server.',
    'log: every request is counted and the ones that would be refused are recorded, but nothing is refused.',
    'enforce: requests over a limit are refused with a "please try again in N minutes" message.',
    'off: nothing is counted.',
    'The public per-visitor limits (login, signup, demo, coupons, payments) stay live in log mode.',
  ],
  budgetsMode: [
    'How the provider budgets behave right now. A developer sets it on the server.',
    'log: every paid call is counted; crossing a cap sends an email but refuses nothing.',
    'enforce: once a provider reaches its cap, the features that need it pause for the rest of the UTC day.',
    'off: nothing is counted.',
  ],
  alertFraction: [
    'When a provider reaches this share of its daily cap, the dev team gets one email; another goes out at the cap itself.',
  ],
  scope: [
    'A scope is a named group of related actions that share one allowance, for example every way of starting a report.',
    'Hover a scope name to read what it covers.',
  ],
  routes: ['How many API endpoints count against this allowance. Hover the number to see them.'],
  per: [
    'Who the allowance belongs to.',
    'caller: the person making the request; each team member has their own allowance.',
    'owner: the account that pays; an agency and all its team members share one allowance.',
    'visitor: the visitor\'s network address, for pages used before login.',
    'API key: one partner API key.',
  ],
  spec: [
    'The allowance written in the code: a count per window, for example 60/hour.',
    'Two windows separated by a semicolon must both hold: 10/minute;200/day means at most 10 a minute and 200 a day.',
    'It is sized at least three times above the busiest real day seen in 90 days.',
  ],
  override: [
    'Replaces the default without a deploy, in the same format (60/hour or 10/minute;200/day).',
    'Empty means the default applies. Changes take effect within about ten seconds.',
  ],
  silenced: [
    'A silenced scope keeps counting and recording what it would refuse, but refuses nothing, even while the mode is enforce.',
    'Use it to switch enforcement on one scope at a time, or to stop a limit that is hurting real customers.',
  ],
  mode: ['What this scope does right now, after the global mode and the silenced flag are applied.'],
  today: [
    'would: requests that log mode would have refused today (nothing was refused).',
    'deny: requests actually refused today.',
    'Days are UTC days. The bar compares this scope with the busiest scope of the day.',
  ],
  lastDenial: ['The most recent account, team member or address over the limit, and when (UTC).'],
  provider: ['An external service POP pays for. Hover a name to read what it is used for.'],
  providerToday: [
    'Paid calls made today on POP\'s own keys. Calls on a customer\'s own key are not counted.',
    'The bar fills towards the cap: amber from 80 %, red at the cap.',
  ],
  cap: [
    'The most calls allowed per UTC day. Empty means no cap.',
    'In enforce mode the features that need this provider pause for the rest of the day once the cap is reached; "Reset today" lifts it.',
    'A sensible first cap is about three times the busiest day observed.',
  ],
  bucket: [
    'One allowance window of one account: the scope, whether it counts for the person or the whole account, the window, and how much of it is used.',
    'Reset clears all of this account\'s windows at once, for a customer locked out by a limit.',
  ],
  modes: {
    log: ['Counting and recording only. Nothing is refused for this scope.'],
    enforce: ['Requests over the limit are refused for this scope.'],
    off: ['Nothing is counted for this scope.'],
  },
  keys: {
    user: ['The person making the request. Each team member has their own allowance.'],
    owner: ['The account that pays. An agency and all its team members share one allowance.'],
    ip: ['The visitor\'s network address, for pages used before login.'],
    custom: ['One partner API key.'],
  },
}
